<template>
  <div class="scrollContent" @mousemove="getMousePos" ref="scrollContent">
    <div class="scroll"
         ref="scroll"
         v-bind:style="styles">
      <slot>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'scrollContent',
  data() {
    return {
      position: 0,
      childHeight: 0,
      height: 650,
      padding: 40,
      posY: 0,
      styles: {
        transform: `translateY(-${this.position}px)`,
      },
    };
  },
  mounted() {
    this.childHeight = this.$refs.scroll.offsetHeight;
    this.height = this.$refs.scrollContent.offsetHeight;
    console.log('页面高度', this.height);
    console.log('子元素高度', this.childHeight);
  },
  methods: {
    getHeight() {
      this.childHeight = this.$refs.scroll.offsetHeight;
      this.height = this.$refs.scrollContent.offsetHeight;
      console.log('页面高度', this.height);
      console.log('子元素高度', this.childHeight);
    },
    getMousePos(event) {
      const e = event || window.event;
      const _local2 = ((this.height * this.padding) / 100);
      const _local3 = (this.height - (_local2 * 2));
      // const _local4 = (this.width - (_local2 * 2));
      const _local5 = _local2;
      // const _local6 = _local2;
      const _local7 = ((e.clientY - _local5) / _local3);
      // const _local8 = ((e.offsetX - _local6) / _local4);
      if (this.height >= this.childHeight) {
        this.posY = 0;
      } else {
        const _local9 = this.height - this.childHeight;
        this.posY = -_local7 * _local9;
        if (_local7 < 0 || _local7 > 1) {
          this.posY = (_local7 < 0) ? 0 : -(_local9);
        }
        this.scrollPercY = ((this.posY / _local9) * -100);
      }
      this.position = this.posY;
      this.styles = this.getStyle(this.position);
      this.$forceUpdate();
    },
    getStyle() {
      const s = {
        transform: `translateY(-${this.position}px)`,
      };
      return s;
    },
  },
};
</script>
<style lang="less" scoped>
.scrollContent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-top: 10px;
  .scroll{
      //pointer-events:none;
      transition: all 2.5s ease 0s
  }
}
</style>
